<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Dialog } from '@progress/kendo-vue-dialogs'

const { t } = useI18n()

const props = defineProps<{
  nestedImageUrl: string
  imageUrl: string
  skuName: string
}>()

const showImagePopup = ref(false)

function openImagePopup() {
  showImagePopup.value = true
}

function closeImagePopup() {
  showImagePopup.value = false
}
</script>

<template>
  <div class="aoe-cart-item-nested-image">
    <button
      type="button"
      class="nested-image-button"
      @click="openImagePopup"
      :aria-label="t('cart.ViewNestedImage', { skuName: props.skuName })"
      data-testid="cart-item-nested-image-button"
    >
      <img
        :src="props.nestedImageUrl"
        class="img-fluid nested-image"
        :alt="t('cart.NestedImageAlt')"
      />
    </button>
    <Dialog
      v-if="showImagePopup"
      :title="props.skuName"
      @close="closeImagePopup"
      @overlayclick="closeImagePopup"
      class="aoe-cart-item-nested-image-dialog"
      data-testid="cart-item-nested-image-dialog"
    >
      <img
        :src="props.imageUrl"
        class="img-fluid nested-image-full"
        :alt="t('cart.NestedImageAlt')"
      />
    </Dialog>
  </div>
</template>

<style lang="scss">
.aoe-cart-item-nested-image {
  margin-top: $spacing-2;
  margin-bottom: $spacing-2;

  .nested-image-button {
    padding: $spacing-0;
    border: 1px solid #80808087;
    border-radius:5px;
    margin-bottom:5px;
    background: none;
    cursor: pointer;
  }

  .nested-image {

    max-height: 80px;
    border-radius: $radius-sm;
  }
}

.aoe-cart-item-nested-image-dialog {
  .nested-image-full {
    display: block;
    max-width: min(90vw, 800px);
    max-height: 80vh;
    margin: 0 auto;
  }
}
</style>
